import React from 'react';

/**
 * Calculates responsive transform, positioning, and fit styles for portraits and property cards.
 * Solves the issue of images being clipped or displaced outside the container frame.
 * Uses native object-position (0-100% X/Y) and transform-origin + scale for smooth,
 * natural zooming and panning without cutting off heads, shoulders, or creating empty gaps.
 */
export function getPositionedImageStyle(
  zoom: number = 100,
  panX: number = 50,
  panY: number = 50,
  fit?: 'cover' | 'contain',
  isDragging?: boolean
): React.CSSProperties {
  const safeZoom = typeof zoom === 'number' && !isNaN(zoom) ? zoom : 100;
  const safePanX = typeof panX === 'number' && !isNaN(panX) ? Math.max(0, Math.min(100, panX)) : 50;
  const safePanY = typeof panY === 'number' && !isNaN(panY) ? Math.max(0, Math.min(100, panY)) : 50;

  const scale = Math.max(0.3, safeZoom / 100);

  // If user selected contain mode, keep contain so no parts of the portrait are cropped
  const effectiveFit = fit === 'contain' ? 'contain' : 'cover';

  return {
    objectFit: effectiveFit,
    objectPosition: `${safePanX}% ${safePanY}%`,
    transform: `scale(${scale})`,
    transformOrigin: `${safePanX}% ${safePanY}%`,
    transition: isDragging ? 'none' : 'transform 0.12s ease-out, object-position 0.12s ease-out'
  };
}
